import React from 'react';
import { SubHeading } from '../../../components/ClientPage';
import { images } from '../../../constants';
import { useTranslation } from 'react-i18next';
import './Header.css';

const Header = () => {
  const { t } = useTranslation();
  const goToHash = (hash) => {
    window.location.href = `/#${hash}`;
  }

  return (
    <div className="app__header app__wrapper section__padding" id="home">
      <div className="app__wrapper_info">
        <SubHeading title={t('header_section.subtitle')} />
        <h1 className="app__header-h1">{t('header_section.title')}</h1>
        <p className="p__opensans" style={{ margin: '2rem 0' }}>
          {t('header_section.description')}
        </p>
        <button type="button" className="custom__button" onClick={(e) => { e.preventDefault(); goToHash('menu'); }}>
          {t('header_section.button')}
        </button>
      </div>

      <div className="app__wrapper_img">
        <img src={images.dining_hall} alt="header_img" />
      </div>
    </div>
  );
};

export default Header;
